/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetCashbackTierRequest
 */
export interface SetCashbackTierRequest {
    /**
     * 
     * @type {string}
     * @memberof SetCashbackTierRequest
     */
    userId: string;
    /**
     * Target cashback tier. One of 3 (member), 5 (silver), 7 (gold).
     * @type {number}
     * @memberof SetCashbackTierRequest
     */
    cashbackPercentageTier: number;
}

/**
 * Check if a given object implements the SetCashbackTierRequest interface.
 */
export function instanceOfSetCashbackTierRequest(value: object): value is SetCashbackTierRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('cashbackPercentageTier' in value) || value['cashbackPercentageTier'] === undefined) return false;
    return true;
}

export function SetCashbackTierRequestFromJSON(json: any): SetCashbackTierRequest {
    return SetCashbackTierRequestFromJSONTyped(json, false);
}

export function SetCashbackTierRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetCashbackTierRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'cashbackPercentageTier': json['cashback_percentage_tier'],
    };
}

export function SetCashbackTierRequestToJSON(json: any): SetCashbackTierRequest {
    return SetCashbackTierRequestToJSONTyped(json, false);
}

export function SetCashbackTierRequestToJSONTyped(value?: SetCashbackTierRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
        'cashback_percentage_tier': value['cashbackPercentageTier'],
    };
}

